import Tool from '../../common/tool';
var MobileFooterMain = /** @class */ (function () {
    function MobileFooterMain() {
        this.footerDom = document.getElementById('footer-mobile');
        this.init();
    }
    MobileFooterMain.prototype.init = function () {
        this.toggleCategory();
        this.setDynamicYear();
    };
    MobileFooterMain.prototype.toggleCategory = function () {
        var categoryItems = Tool.$_selectAll(this.footerDom, '.daetool-mobile-footer-item');
        var categoryTitles = Tool.$_selectAll(this.footerDom, '.daetool-mobile-footer-item-title');
        categoryTitles.forEach(function (title, index) {
            title.addEventListener('click', function () {
                categoryItems[index].classList.toggle('active');
            });
        });
    };
    MobileFooterMain.prototype.setDynamicYear = function () {
        var dynamicLifeDom = Tool.$_select(this.footerDom, '.dynamicLife');
        dynamicLifeDom.innerHTML = String(new Date().getFullYear());
    };
    return MobileFooterMain;
}());
export default MobileFooterMain;
